import { useToast } from '@shared/components/toast';
import {
  DatHistoryRatesPayload,
  useFindOrCreateDatHistoryRatesMutation,
} from '@shared/generated/graphql';
import { useMemo } from 'react';

export const useDATHistoryRatesMutation = (quoteId: string) => {
  const [findOrCreateDATHistoryRates, { data, loading }] =
    useFindOrCreateDatHistoryRatesMutation();
  const { sendToast } = useToast();

  const fetchDATHistoryRatesMutation = async () => {
    await findOrCreateDATHistoryRates({
      variables: {
        input: {
          id: quoteId,
        },
      },
    }).catch((err) => {
      sendToast(`Could not fetch DAT history rates. ${err.message}`, {
        variant: 'info',
      });
    });
  };

  const historyRates = useMemo(() => {
    if (!data?.findOrCreateDATHistoryRates) return undefined;
    return data.findOrCreateDATHistoryRates as DatHistoryRatesPayload;
  }, [data]);

  return {
    fetchDATHistoryRatesMutation,
    historyRates,
    loading,
  };
};
